import get from 'lodash/get';

// Old selectors, refactor or delete
export const getAuthType = (state: any) => get( state, 'user.authType', null );
export const getLocaleCode = (state: any) => get( state, 'user.locale', 'en_US' );
export const getFirstTimeSetupDone = (state: any) => get( state, 'user.firstTimeSetupDone', true );
export const getIsLaunchAs = (state: any) => get( state, 'user.isLaunchAs', false );
export const getLanguageOverride = (state: any) => get( state, 'user.loginLanguageOverride', false );

// New selectors
export const getFirstName = (state: any) => get( state, 'user.claims.given_name' ) || '';
export const getLastName = (state: any) => get( state, 'user.claims.family_name' ) || '';
export const getFullName = (state: any) => get( state, 'user.claims.name' ) || '';
export const getUserInitials = (state: any) => get( state, 'user.claims.initials', '' ).toUpperCase() || '';
export const getHasOTS = (state: any) => get( state, 'user.some.ots.path' ) || false; // TODO figure out where this should come from
export const getUserAuthenticated = (state: any) => !!get( state, 'user.access_token' );
export const getUserName = (state: any) => get( state, 'user.claims.preferred_username' ) || '';
export const getUserCountryCode = (state: any) => get( state, 'user.claims.country' ) || '';
export const getUserEmail = (state: any) => {
    const emails = get( state, 'user.claims.email' ) || {};
    return emails[ Object.keys( emails )[ 0 ] ] || '';
};

// WIP selectors - don't know where data is coming from just yet
export const getIsLoginAs = (state: any) => false;
export const getAccountBalance = (state: any) => 0;
export const getAvatarUrl = (state: any) => get( state, 'user.claims.avatarUrl', '' );
